// useFocusTrap.js
import { onMounted, onBeforeUnmount, nextTick, ref } from 'vue'

export function useFocusTrap(containerRef, options = {}) {
	const lastFocusedEl = ref(null)
	const { onKeydown } = options

	const getFocusableElements = (root) => {
		if (!root) return []
		return Array.from(
			root.querySelectorAll(
				'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
			)
		).filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'))
	}

	const handleKeydown = (event) => {
		// --- Focus trap logic ---
		if (event.key === 'Tab') {
			const focusableEls = getFocusableElements(containerRef.value)
			if (focusableEls.length === 0) {
				event.preventDefault()
				return
			}

			const firstEl = focusableEls[0]
			const lastEl = focusableEls[focusableEls.length - 1]

			if (event.shiftKey) {
				// Shift+Tab
				if (document.activeElement === firstEl) {
					event.preventDefault()
					lastEl.focus()
				}
			} else {
				// Tab
				if (document.activeElement === lastEl) {
					event.preventDefault()
					firstEl.focus()
				}
			}
		}

		// --- Component-specific logic ---
		if (typeof onKeydown === 'function') {
			onKeydown(event)
		}
	}

	onMounted(() => {
		lastFocusedEl.value = document.activeElement

		nextTick(() => {
			const focusableEls = getFocusableElements(containerRef.value)
			if (focusableEls.length) {
				focusableEls[0].focus()
			} else {
				containerRef.value.setAttribute('tabindex', '-1')
				containerRef.value.focus()
			}
		})

		document.addEventListener('keydown', handleKeydown)
	})

	onBeforeUnmount(() => {
		document.removeEventListener('keydown', handleKeydown)
		if (lastFocusedEl.value) {
			lastFocusedEl.value.focus()
		}
	})
}
